var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"add-partner",attrs:{"tag":"div","to":{name: 'create-partner'}}},[_c('div',[_vm._v(" + ")]),_c('div',[_vm._v(" Додати точку ")])])}
var staticRenderFns = []

export { render, staticRenderFns }